import { g, random } from "../../util/index.ts";

const genWeight = (hgt: number, stre?: number, pos?: string) => {
	const MIN_WEIGHT = 155;
	const MAX_WEIGHT = 305;

	if (stre === undefined) {
		stre = hgt;
	}

	const female = g.get("gender") === "female";

	const weight =
		random.randInt(-20, 20) + ((hgt + 0.5 * stre) * (MAX_WEIGHT - MIN_WEIGHT)) / 150 + MIN_WEIGHT;

	const weightAdjusted = weight * g.get("weightFactor");

	if (female) {
		// Ratio comes from average USA stats, adjusted a bit down because they still seem to high
		return Math.round(0.75 * weightAdjusted);
	}

	return Math.round(weightAdjusted);
};

export default genWeight;
